<ng-container [formGroup]="parentFormGroup">
  <pg-switch
    [disabled]="model?.disabled"
    [aria-label]="model?.ariaLabel"
    [aria-labelledby]="model?.ariaLabelledby"
    [labelPosition]="model?.labelPosition"
    [styleOverrides]="model"
  >
    <pg-on-label *ngIf="model?.onLabel && model?.offLabel">
      {{ model.onLabel }}
    </pg-on-label>
    <pg-off-label *ngIf="model?.onLabel && model?.offLabel">
      {{ model.offLabel }}
    </pg-off-label>
  </pg-switch>
</ng-container>
